// #region Imports

import Vue from 'vue';

// #endregion

// #region Component Registration

Vue.component('AccountCustomerPaymentCreate', () => import(/* webpackChunkName: "account-pages" */ '@/account/customer/AccountCustomerPaymentCreate.vue'));
Vue.component('AccountCustomerBillingAddress', () => import(/* webpackChunkName: "account-pages" */ '@/account/customer/AccountCustomerBillingAddress.vue'));

// #endregion
